import { StylingModel } from '../models/style/styling.model';
import { IconModel } from '../models/icon/icon.model';
import { IconStylingModel } from '../models/icon/icon-styling.model';
import { ButtonModel } from '../models/button/button.model';
import { ButtonStylingModel } from '../models/button/button-styling.model';
import { MenuModel } from '../models/menu/menu.model';
import { ToolbarModel } from '../models/toolbar/toolbar.model';
import { DialogModel } from '../models/dialog/dialog.model';
import { DialogStylingModel } from '../models/dialog/dialog-styling.model';

export const /** @type {?} */ DialogTemplates = {
  defaultTemplate: {
    property: new DialogModel({
      display: true,
      disable: false,
      targetId: '',
      sourceEvent: null,
      position: 'auto',
      disableClose: false,
      height: '',
      width: '',
      header: {
        show: true,
        toolbar: new ToolbarModel({
          type: 'info',
          info: {
            show: true,
            icon: new IconModel({ name: 'info' }),
            order: 0
          },
          content: {
            show: true,
            title: '',
            template: null,
            order: 1
          },
          actions: {
            show: false,
            menu: null,
            order: 2
          },
          help: {
            show: true,
            icon: new IconModel({ name: 'help_outline' }),
            order: 3
          },
          close: {
            show: true,
            icon: new IconModel({ name: 'highlight_off' }),
            order: 4
          },
          maximization: {
            show: false,
            maximized: false,
            minimizeIcon: null,
            maximizeIcon: null,
            order: 5
          },
          expandable: {
            show: false,
            expanded: true,
            icon: null,
            order: 6
          }
        }),
      },
      content: {
        show: true,
        message: '',
        template: null
      },
      footer: {
        show: true,
        cancelButton: {
          show: true,
          button: new ButtonModel({ label: 'Cancel' })
        },
        okButton: {
          show: true,
          button: new ButtonModel({ label: 'Ok' })
        },
        template: null
      }
    })
  }
}
